export const feetPerMeter = 3.28084;
export const metersPerNauticalMile = 1852;
